import script from "./illustrate.vue?vue&type=script&setup=true&lang=js"
export * from "./illustrate.vue?vue&type=script&setup=true&lang=js"

import "./illustrate.vue?vue&type=style&index=0&id=764928ee&lang=less&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-764928ee"]])

export default __exports__